export const changeStatus = (type, message) => {
  return {
    type: type,
    message: message,
  }
}
